/*
This file is located in the main branch
Last time the file was updated (UTC): [27.01.2024 4:51:32]
Permissions to update outside the main branch: [false]
*/

import { Role, RoleTableItem } from 'models/api/roles';

export function roleTableItemToRole(r: RoleTableItem): Role {
    return {
        id: r.id?.toString() || '',
        dsc: r.dsc,
        name: r.name,
        typeId: r.typeId,
        rank: r.rank,
        tradeOrgBindable: r.tradeOrgBindable,
        brandCodeBindable: r.brandCodeBindable,
    };
}
